import Axios from "axios"
import Store from "./Js/Store"

class API {

    constructor() {
        this.client = Axios.create({
            baseURL: this.baseURL + "/",
            timeout: 0
        });

        this.client.interceptors.response.use(undefined, function (error) {
            if (!error || !error.response)
                return Promise.reject("");

            if (error.response.status === 401 || error.response.status === 500) {
                //ipcRenderer.send('response-unauthenticated');
                Store.state.error.data = error.response.data;
                Store.state.error.show = true;

                return Promise.reject(error);
            }
        });
    }

    get baseURL() {
        return `${window.location.protocol}//${window.location.host}/api/`;
    }

    get CancelToken() {
        return Axios.CancelToken;
    }
    
    get(path, cancelToken) {
        return this.client.get(path, cancelToken);
    }

    post(path, data) {
        return this.client.post(path, data);
    }

    upload(path, file) {
        const formData = new FormData();
        formData.append("file", file);

        return this.client.post(path,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });
    }
}

const api = new API();

export default api
